var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M269.5,41.9644661 L269.5,21.5 C269.5,20.1192881 270.619288,19 272,19 C273.380712,19 274.5,20.1192881 274.5,21.5 L274.5,41.9644661 L277.732233,38.732233 C278.708544,37.7559223 280.291456,37.7559223 281.267767,38.732233 C282.244078,39.7085438 282.244078,41.2914562 281.267767,42.267767 L273.767767,49.767767 C272.791456,50.7440777 271.208544,50.7440777 270.232233,49.767767 L262.732233,42.267767 C261.755922,41.2914562 261.755922,39.7085438 262.732233,38.732233 C263.708544,37.7559223 265.291456,37.7559223 266.267767,38.732233 L269.5,41.9644661 Z","transform":"rotate(-90 132 150.75)"}));
}

ArrowRightInline.defaultProps = {"width":"32","height":"21","viewBox":"0 0 32 21"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
